import { cateringModulePermission, reportsModulePermission } from '../DashboardModule/modulepermissions';

export const accountantReportPermissions = [
  reportsModulePermission['reports-visible-module'],
  reportsModulePermission['reports-visible'],
  reportsModulePermission['reports-create'],
  reportsModulePermission['reports-read'],
];

export const accountantDefaultCateringFeaturePermission = [
  cateringModulePermission['catering-visible'],
  cateringModulePermission['invoice-management-read'],
  cateringModulePermission['invoice-management-edit'],
  cateringModulePermission['invoice-management-create'],
];
